import { useEffect, useState } from 'react';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'react-router';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import petraPng from './images/cpp-petra.png';
import nobgPng from './images/Untitled-nobg.png';
import cskaHomeTitlePng from './images/cska-sofia.png';
import logoaiPng from './images/logoai.png';
import sunnyagencyPng from './images/sunnyagency.png';
import codwiseLogoPng from './images/logo-codwise.png';
import clearHomeImg from './images/clearhome-logo.webp';
import bniproTitlePng from './images/bnipro-logo.jpg';
import consultbgTitlePng from './images/logo-consultbg.png';
import euroffTitlePng from './images/euroff-logo.jpg';
import maxgroupPng from './images/maxgroup-logo.png';
import flowerplantsPng from './images/flowerplants.png';
import governmentPng  from './images/sacp_logo.png';
import toiletcabinsPng  from './images/esteta_logo.png';
import s4Jpg from './images/s4.jpg';
import ddobrevaJpg from './images/ddobreva.jpg';
import iwanJpg from './images/iwan.jpg';
import vartigovJpg from './images/vartigov.png';
import nadejdaJpg from './images/nadejda_ivanova.jpg';
import blueBreezePng from './images/bluebreeze.png';
import petkovaPng from './images/petkova-logo.png';
import vitPng from './images/vit-logo.png';
import avmPng from './images/avm-logo.png';
import mrSenkov from './images/mr-senkov.png';
import cyberKidz from './images/cyberkidzpatrol.png';
import { lng } from './js/language.js';

function Projects() {

    const [widthDisplay, setWidthDisplay] = useState(window.innerWidth);
    function handleWindowSizeChange() {
        setWidthDisplay(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);
    const isMobile = widthDisplay <= 768;

    const [currentLangObj, setCurrentLangObj] = useState(lng[localStorage.getItem('currentLang') || 'bg']);
    function handleCheckLang() {
        setCurrentLangObj(lng[localStorage.getItem('currentLang') || 'bg']);
    }
    useEffect(() => {
        window.addEventListener('click', handleCheckLang);
        return () => {
            window.removeEventListener('click', handleCheckLang);
        };
    }, []);

    return  (
                <>
                    <section className="projects">
                        <div className="container">
                            <div className="title text-center">
                                <h1 className="title-blue our-projects">{currentLangObj.ourProjects}</h1>
                                <p className="our-projects-text">{currentLangObj.ourProjectsText}</p>
                            </div>
                            <div className="row clients">
                                <div className="col-sm-3 col-lg-3">
                                    <div className="client">
                                        <Link to="https://sacp.government.bg/"  target="_blank">
                                            <div className="opinion-img-frame">
                                                <img className="mr-11 opinion-img" src={governmentPng} alt="" />
                                            </div>
                                        </Link>
                                        <hr />
                                        <h6 className="title-clients title-primary text-center">{currentLangObj.partner10}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-lg-3">
                                    <div className="client">     
                                        <Link to="https://cska-basket.bg"  target="_blank">
                                            <div className="opinion-img-frame">
                                                <img className="mr-11 opinion-img border-radius-5" src={cskaHomeTitlePng} alt="https:/cska-basket.bg" />
                                            </div>
                                        </Link>
                                        <hr />
                                        <h6 className="title-clients title-primary text-center">
                                            {currentLangObj.partner3}
                                        </h6>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-lg-3">
                                    <div className="client">     
                                        <Link to="https://clearhome.bg"  target="_blank">
                                            <div className="opinion-img-frame">
                                                <img className="mr-11 opinion-img border-radius-5" src={clearHomeImg} alt="https://clearhome.bg" />
                                            </div>
                                        </Link>
                                        <hr />
                                        <h6 className="title-clients title-primary text-center">
                                            {currentLangObj.partner23}
                                        </h6>
                                    </div>
                                </div>
                                                                <div className="col-sm-3 col-lg-3">
                                    <div className="client">     
                                        <Link to="https://bniprobulgaria.com"  target="_blank">
                                            <div className="opinion-img-frame">
                                                <img className="mr-11 opinion-img border-radius-5" src={bniproTitlePng} alt="https:/bniprobulgaria.com" />
                                            </div>
                                        </Link>
                                        <hr />
                                        <h6 className="title-clients title-primary text-center">
                                            {currentLangObj.partner24}
                                        </h6>
                                    </div>
                                </div>
                                                                <div className="col-sm-3 col-lg-3">
                                    <div className="client">
                                        <Link to="https://vit.bg/"  target="_blank">
                                            <div className="opinion-img-frame">
                                                <img className="mr-11 opinion-img" src={vitPng} alt="" />
                                            </div>
                                        </Link>
                                        <hr />
                                        <h6 className="title-clients title-primary text-center">{currentLangObj.partner13}</h6>
                                    </div>
                                </div>
                                
                                <div className="col-sm-3 col-lg-3">
                                    <div className="client">
                                        <Link to="https://mrsenkov.bg"  target="_blank">
                                            <div className="opinion-img-frame">
                                                <img className="mr-11 opinion-img" src={mrSenkov} alt="" />
                                            </div>
                                        </Link>
                                        <hr />
                                        <h6 className="title-clients title-primary text-center">{currentLangObj.partner16}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-lg-3">
                                    <div className="client">     
                                        <Link to="https://consultbg.eu"  target="_blank">
                                            <div className="opinion-img-frame">
                                                <img className="mr-11 opinion-img border-radius-5" src={consultbgTitlePng} alt="https://consultbg.eu" />
                                            </div>
                                        </Link>
                                        <hr />
                                        <h6 className="title-clients title-primary text-center">
                                            {currentLangObj.partner25}
                                        </h6>
                                    </div>
                                </div>
                                                                <div className="col-sm-3 col-lg-3">
                                    <div className="client">     
                                        <Link to="https://euro-ff.com/"  target="_blank">
                                            <div className="opinion-img-frame">
                                                <img className="mr-11 opinion-img border-radius-5" src={euroffTitlePng} alt="https://euro-ff.com/" />
                                            </div>
                                        </Link>
                                        <hr />
                                        <h6 className="title-clients title-primary text-center">
                                            {currentLangObj.partner26}
                                        </h6>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-lg-3">
                                    <div className="client">
                                        <Link to="https://jivotasiti.com"  target="_blank">
                                            <div className="opinion-img-frame">
                                                <img className="mr-11 opinion-img" src={petraPng} alt="https://jivotasiti.com" />
                                            </div>
                                        </Link>
                                        <hr />
                                        <h6 className="title-clients title-primary text-center">{currentLangObj.partner1}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-lg-3">
                                    <div className="client">
                                        <Link to="https://www.razsadi.net/"  target="_blank">
                                            <div className="opinion-img-frame">
                                                <img className="mr-11 opinion-img" src={nobgPng} alt="https://www.razsadi.net/" />
                                            </div>
                                        </Link>
                                        <hr />
                                        <h6 className="title-clients title-primary text-center">{currentLangObj.partner2}</h6>
                                    </div>
                                </div>

                                <div className="col-sm-3 col-lg-3">
                                    <div className="client">
                                        <Link to="https://adrianaivanova.com"  target="_blank">
                                            <div className="opinion-img-frame">
                                                <img className="mr-11 opinion-img" src={logoaiPng} alt="https://adrianaivanova.com/" />
                                            </div>
                                        </Link>
                                        <hr />
                                        <h6 className="title-clients title-primary text-center">{currentLangObj.partner4}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-lg-3">
                                    <div className="client">     
                                        <Link to="https://sunnyagency.eu"  target="_blank">
                                            <div className="opinion-img-frame">
                                                <img className="mr-11 opinion-img" src={sunnyagencyPng} alt="https://sunnyagency.eu" />
                                            </div>
                                        </Link>
                                        <hr />
                                        <h6 className="title-clients title-primary text-center">{currentLangObj.partner5}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-lg-3">
                                    <div className="client">
                                        <Link to="https://avm.vekotasoft.com/"  target="_blank">
                                            <div className="opinion-img-frame">
                                                <img className="mr-11 opinion-img" src={avmPng} alt="" />
                                            </div>
                                        </Link>
                                        <hr />
                                        <h6 className="title-clients title-primary text-center">{currentLangObj.partner14}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-lg-3">
                                    <div className="client">
                                        <Link to="https://apps.apple.com/bg/app/cyberkidz-patrol/id6753713110"  target="_blank">
                                            <div className="opinion-img-frame">
                                                <img className="mr-11 opinion-img" src={cyberKidz} alt="" />
                                            </div>
                                        </Link>
                                        <hr />
                                        <h6 className="title-clients title-primary text-center">{currentLangObj.partner15}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-lg-3">
                                    <div className="client">
                                        <Link to="https://codwise.vekotasoft.com/"  target="_blank">
                                            <div className="opinion-img-frame">
                                                <img className="mr-11 opinion-img" src={codwiseLogoPng} alt="" />
                                            </div>    
                                        </Link>
                                        <hr />
                                        <h6 className="title-clients title-primary text-center">{currentLangObj.partner27}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-lg-3">
                                    <div className="client"> 
                                        <Link to="https://maxgroupevents.org"  target="_blank">
                                            <div className="opinion-img-frame">
                                                <img className="mr-11 opinion-img" src={maxgroupPng} alt="" />
                                            </div>
                                        </Link>
                                        <hr />
                                        <h6 className="title-clients title-primary text-center">{currentLangObj.partner7}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-lg-3">
                                    <div className="client">
                                        <Link to="https://flowerplants.eu"  target="_blank">
                                            <div className="opinion-img-frame">
                                                <img className="mr-11 opinion-img" src={flowerplantsPng} alt="" />
                                            </div>
                                        </Link>
                                        <hr />
                                        <h6 className="title-clients title-primary text-center">{currentLangObj.partner8}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-lg-3">
                                    <div className="client"> 
                                        <Link to="https://toilet-cubicles.bg/"  target="_blank">
                                            <div className="opinion-img-frame">
                                                <img className="mr-11 opinion-img" src={toiletcabinsPng} alt="" />
                                            </div>
                                        </Link>
                                        <hr />
                                        <h6 className="title-clients title-primary text-center">{currentLangObj.partner9}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-lg-3">
                                    <div className="client">
                                        <Link to="https://bluebreeze-travel.com/"  target="_blank">
                                            <div className="opinion-img-frame">
                                                <img className="mr-11 opinion-img" src={blueBreezePng} alt="" />
                                            </div>
                                        </Link>
                                        <hr />
                                        <h6 className="title-clients title-primary text-center">{currentLangObj.partner11}</h6>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-lg-3">
                                    <div className="client">
                                        <Link to="https://petkova.bg/"  target="_blank">
                                            <div className="opinion-img-frame">
                                                <img className="mr-11 opinion-img" src={petkovaPng} alt="" />
                                            </div>
                                        </Link>
                                        <hr />
                                        <h6 className="title-clients title-primary text-center">{currentLangObj.partner12}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>            
                    </section>

                    <section className="testimonial-and-clients">
                        <div className="container">
                            <div className="testimonials">
                                <div className="title text-center">
                                    <h1 className="">{currentLangObj.reviews}</h1>
                                    <br />
                                </div>
                                 <Swiper
                                    style={{
                                        '--swiper-navigation-color': '#ee1515',
                                        '--swiper-pagination-color': '#ee1515',
                                        '--swiper-navigation-sides-offset': '-5px',
                                        '--swiper-pagination-bullet-inactive-color': '#ffffff',
                                        '--swiper-pagination-bottom': '-5px',
                                    }}
                                    modules={[Navigation, Pagination, A11y]}
                                    spaceBetween={50}
                                    slidesPerView={1}
                                    loop={true}
                                    navigation
                                    pagination={{ clickable: true }}
                                    // onSwiper={(swiper) => console.log(swiper)}
                                    // onSlideChange={() => console.log('slide change')}
                                >
                                    <SwiperSlide>
                                        <div className="swiper-slide text-center">
                                            <div className="row">
                                                <div className="offset-lg-1 col-lg-10">
                                                    <div className="test-img">
                                                        <img src={s4Jpg} alt="Adriana Ivanova" />
                                                    </div>
                                                    <h5>Адриана Иванова</h5>
                                                    <span>специалист продажби</span>
                                                    <p>
                                                        Работата с Векота беше най-доброто решение за изграждането
                                                        на уебсайта за моя личен бранд. Бях притисната от времето, без ясна визия и с
                                                        хиляди идеи в главата си – а те успяха не просто да се ориентират в целия хаос,
                                                        а да го подредят, структурират и превърнат в смислен и функционален краен
                                                        продукт.
                                                    </p>
                                                    <p className={isMobile ? 'hidden' : ''}>
                                                        Действаха бързо, професионално и с огромно внимание към
                                                        детайла. Обясняваха
                                                        всичко на ясен и достъпен език, даваха ми възможност за информиран избор и
                                                        създаваха усещане за сигурност.</p>
                                                    <p className={isMobile ? 'hidden' : ''}>
                                                        Комуникацията беше изключително лесна, ефективна и човешка –
                                                        рядко срещана
                                                        комбинация. Работата вървеше с лекота. Получих не просто уебсайт, а партньорство
                                                        с добавена стойност, което ми спести време, енергия и стрес.</p>
                                                    <p>
                                                        Препоръчвам с две ръце на всеки, който иска резултат,
                                                        надхвърлящ очакванията!
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="swiper-slide text-center">
                                            <div className="row">
                                                <div className="offset-lg-1 col-lg-10">
                                                    <div className="test-img">
                                                        <img src={ddobrevaJpg} alt="Dora Dobreva" />
                                                    </div>
                                                    <h5>Дора Даскалова</h5>
                                                    <span>психолог</span>
                                                    <p>
                                                        Когато за пръв път се срещнах с Орлин, нямах напълно
                                                        изяснена концепция за визията и функционалностите на сайта, който исках да
                                                        създам. Въпреки това той подхождаше с внимание, търпение и професионализъм, като
                                                        ми вдъхна спокойствие и увереност, че съм в добри ръце.
                                                    </p>    
                                                    <p className={isMobile ? 'hidden' : ''}>
                                                        В процеса на работа, чрез спокойни и целенасочени разговори,
                                                        Орлин успя точно да разбере какво търся, дори когато самата аз не можех да го
                                                        формулирам напълно ясно. Предложенията му бяха аргументирани, ориентирани към
                                                        практичността и в полза на бъдещата употреба на сайта. Всеки етап от
                                                        разработката беше съпътстван от открито и конструктивно общуване.</p>
                                                    <p className={isMobile ? 'hidden' : ''}>
                                                        Откликваше своевременно на всички мои въпроси и корекции,
                                                        като поддържаше постоянна комуникация и яснота в работния процес. В резултат,
                                                        получих сайт, който отговаря не само на техническите изисквания, но и на
                                                        усещането ми за стил, съдържание и функционалност.</p>
                                                    <p>
                                                        Благодаря за професионалния подход и партньорско отношение
                                                        през цялото време на съвместната ни работа.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="swiper-slide text-center">
                                            <div className="row">
                                                <div className="offset-lg-1 col-lg-10">
                                                    <div className="test-img">
                                                        <img src={iwanJpg} alt="Ivan Arabadjiev" />
                                                    </div>
                                                    <h5>Иван Арабаджиев</h5>
                                                    <span>ОАКПЛАНТС 78 ЕООД</span>
                                                    <p>
                                                        Като управител на Оакплантс 78 ЕООД, бих искал да изразя
                                                        своята благодарност за професионализма и коректността, с които екипът на Векота
                                                        работи.
                                                    </p>
                                                    <p>
                                                        Ние много ценим техния ангажимент към клиентите и
                                                        иновациите, които внедряват.
                                                    </p>
                                                    <p>
                                                        Със съвместната ни работа сме постигнали отлични резултати и
                                                        горещо препоръчвам Векота ЕООД като надежден партньор за всеки бизнес.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="swiper-slide text-center">
                                            <div className="row">
                                                <div className="offset-lg-1 col-lg-10">
                                                    <div className="test-img">
                                                        <img src={vartigovJpg} alt="Иван Въртигов" />
                                                    </div>
                                                    <h5>Иван Въртигов</h5>
                                                    <span>MAX GROUP EVENTS</span>
                                                        <p>Изключително сме доволни от работата на Векота. 
                                                            Поръчахме разработка на специализиран софтуер за нашата агенция и резултатът надмина очакванията ни. 
                                                        Екипът е много професионален, комуникативен и реагира бързо на всички наши въпроси и изисквания. 
                                                        </p>
                                                        <p className={isMobile ? 'hidden' : ''}>
                                                            Софтуерът е интуитивен, стабилен и напълно съобразен с нуждите на бизнеса ни.
                                                        </p>
                                                        <p>
                                                            Препоръчвам Векота на всеки, който търси надежден партньор в разработката на софтуерни решения. Благодарим за отличното сътрудничество!
                                                        </p>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="swiper-slide text-center">
                                            <div className="row">
                                                <div className="offset-lg-1 col-lg-10">
                                                    <div className="test-img">
                                                        <img src={nadejdaJpg} alt="Надежда Иванова" />
                                                    </div>
                                                    <h5>Надежда Иванова</h5>
                                                    <span>Естета дизайн</span>
                                                <p> 
                                                        Ползвах услугите на фирма „Векота“ при изграждането на фирмения ми сайт. 
                                                        Мога да изкажа изключително положително мнение, като подчертая, че г-н Орлин Матеев е коректен и отзивчив професионалист.
                                                    </p>
                                                    <p className={isMobile ? 'hidden' : ''}>
                                                        Проектът по изграждането на сайта беше реализиран в договорения срок, при стриктно спазване на всички поставени изисквания, с дизайн, който напълно отговаря на очакванията ни, и ясно структурирано съдържание. Получихме професионална консултация, както и пълна подкрепа и съдействие при решаването на възникнали казуси през целия процес на работа.
                                                    </p>
                                                    <p>Препоръчваме фирма „Векота“ като надежден и отговорен партньор.</p>                                                 
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                </Swiper>
                            </div>
                        </div>
                    </section>
                </>
            );
    }

export default Projects;
